import moment from "moment";
import { round } from "./MathUtils";

export const formatPercentage = (percentage: number, decimals: number) => {
    return 100 * round(percentage, decimals);
}